export default class VideoPlayerRegistry {
  constructor (element) {
    this._players = []
  }

  add (videoPlayerController) {
    console.log('adding', videoPlayerController)
    this._players.push(videoPlayerController)
  }

  muteAll () {
    this._players.map(p => p.mute())
  }
}
